import { Suspense } from "react";

import { CSubheader } from "@coreui/react";

import CHeader from "../CHeader";
import CTabs from "../CHeader/CTabs";
import { HEADER_HEIGHT } from "../constants";
import CRoutes from "../CRoutes";
import CSidebar from "../CSidebar";

const MainLayout = () => {
  return (
    <div className="relative w-screen" style={{ height: "100dvh" }}>
      <CHeader />
      <div
        className="flex flex-row overflow-hidden w-screen"
        style={{
          height: `calc(100dvh - ${HEADER_HEIGHT}px)`,
          maxHeight: `calc(100dvh - ${HEADER_HEIGHT}px)`,
        }}
      >
        <CSidebar />
        <main className="flex-1 !px-4 !lg:px-6 !my-4 overflow-x-hidden overflow-y-auto">
          <CSubheader className="w-100">
            <CTabs />
          </CSubheader>
          <Suspense fallback={null}>
            <CRoutes />
          </Suspense>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
